import { render } from "./ModalAssociarContaTeste.vue?vue&type=template&id=2993cb84&scoped=true"
import script from "./ModalAssociarContaTeste.vue?vue&type=script&lang=js"
export * from "./ModalAssociarContaTeste.vue?vue&type=script&lang=js"

import "./ModalAssociarContaTeste.vue?vue&type=style&index=0&id=2993cb84&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2993cb84"]])

export default __exports__